<script lang="ts">
  import Card from './Card.svelte';
  import CardInput from './CardInput.svelte';

  import { writable } from 'svelte/store';
  import LZString from 'lz-string';

  const NO_CARD_MAGIC_STRING = "---";
  let saved_cards = {};
  let saved_cards_keys = [NO_CARD_MAGIC_STRING];
  let selected_saved_card = NO_CARD_MAGIC_STRING;
  const saved_cards_store = writable<object>(JSON.parse(localStorage.getItem("saved_cards")) || {} );
  saved_cards_store.subscribe(v => {
    if (Object.keys(v).length > 0) {
      saved_cards = v;
      saved_cards_keys = Object.keys(v).sort();
    } else {
      saved_cards = {};
      saved_cards_keys = [NO_CARD_MAGIC_STRING]
    }
    selected_saved_card = saved_cards_keys[0];
  })
  saved_cards_store.update(n => n); // Dummy update
  saved_cards_store.subscribe((value) => localStorage.setItem("saved_cards", JSON.stringify(value)));

  const MAX_CARDS = 9;
  let cards = [];
  let mhp = {
    name: "Minor healing potion",
    type: "Item 1",
    tags: ["Consumable", "Healing", "Magical", "Necromancy", "Positive", "Potion"],
    attributes: `<p><b>Usage</b> Held in 1 hand; <b>Bulk</b> L</p>
	      <p><b>Activate (A)</b> Interact</p>`,
    description: `<p>A healing potion is a vial of a ruby-red liquid that imparts a tingling sensation as the drinker’s wounds heal rapidly. When you drink a healing potion, you regain 1d8 Hit Points.</p>`
  };

  if (window.location.hash !== "") {
    cards = JSON.parse(LZString.decompressFromEncodedURIComponent(window.location.hash.substring(1)));
  } else {
    cards = [{id: 0, ...mhp}];
  }
  
  function get_idx_by_id(id) {
    for(let idx = 0; idx < cards.length; idx++) {
      if(id === cards[idx].id) {
	      return idx;
      }
    }
  }

  function chunk(arr) {
    let larr = [...arr], out = [];
    while(larr.length) {
      out = [...out, (larr.splice(0,MAX_CARDS))];
    };
    return out;
  }
  $: pages = chunk(cards);

  let selector = cards[0].id;
  $: selected_card = cards.filter(x => x.id === selector)[0];
  $: selected_idx = get_idx_by_id(selector);

  $: window.location.hash = LZString.compressToEncodedURIComponent(JSON.stringify(cards));

  function change_tags(e) {
    selected_card.tags = e.detail.tags.split(',').map(x => x.replace(/\s+/g, '')).filter(x => x != '');
    cards[selected_idx] = selected_card;
  }
  
  function add_card() {
    cards = [...cards, {id: cards[cards.length-1].id+1, ...mhp}];
    selector = cards[cards.length-1].id;
  }

  function remove_card() {
    console.log(cards);
    console.log(selected_idx);
    if (cards.length > 1) { // remove only if there is more than 1 card
      cards = cards.filter(x => x.id != selector);
      if (selected_idx >= cards.length) {
	      selector = cards[cards.length-1].id;
      } else {
	      selector = cards[selected_idx].id;
      }
    }
  }

  function save_card() {
    saved_cards_store.update(n => {
      let to_save = {};
      for (let key in selected_card) {
        if (key !== "id") {
          to_save[key] = selected_card[key];
        }
      }
      n[to_save["name"]] = to_save;
      return n;
    });
  }

  function load_card() {
    if (selected_saved_card !== NO_CARD_MAGIC_STRING) {
      let new_card = saved_cards[selected_saved_card];
      selected_card.name = new_card.name;
      selected_card.type = new_card.type;
      selected_card.tags = new_card.tags;
      selected_card.attributes = new_card.attributes;
      selected_card.description = new_card.description;
      cards = cards;
    }
  }

  function delete_card() {
    saved_cards_store.update(n => {
      delete n[selected_saved_card];
      return n;
    })
  }
</script>

<main>
  <section class="controls">
    <h1>PF2e card generator</h1>
    <CardInput bind:name={selected_card.name} bind:type={selected_card.type} tags={selected_card.tags} bind:attributes={selected_card.attributes} bind:description={selected_card.description} bind:saved_cards={saved_cards_keys} bind:selected_saved_card={selected_saved_card} on:change_tags={change_tags} on:add_card={add_card} on:remove_card={remove_card} on:save_card={save_card} on:load_card={load_card} on:delete_card={delete_card}/>
  </section>
  {#each pages as page}
  <section class="cards">
    {#each page as card, idx (card.id)}
      <div class="card" style="break-after:avoid;">
	<Card {...card}/>
	<input class="card-selector" type="radio" bind:group={selector} value={card.id}/>
      </div>
    {/each}
  </section>
  {/each}
</main>

<style>
  @media print {
    @page {
      margin: 7mm;
    }
    .controls {
      display: none;
    }
    .card-selector {
      display: none;
    }
  }
  .cards {
    display: flex;
    flex-wrap: wrap;
    break-after: always;
  }
  h1 {
    text-transform: uppercase;
    font-size: 4em;
    font-weight: 100;
  }

</style>
